import React from 'react';
import {
  Box,
  Button,
  IconButton,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from '@mui/material';
import { Add, Delete, Edit } from '@mui/icons-material';
import { getMappingTableColumns, MAPPING_TYPE } from './transformationMappingUiConfig';

const cellSx = { fontSize: '0.8125rem', py: 0.75 };
const headSx = {
  backgroundColor: '#F8F8F8',
  color: '#6B0F2A',
  fontWeight: 600,
  fontSize: '0.875rem',
  py: 1,
};

const TransformationMappingTable = ({
  mappings,
  type,
  onAdd,
  onEdit,
  onDelete,
  loading,
}) => {
  const columns = getMappingTableColumns(type);
  const label = type === MAPPING_TYPE.HEADER ? 'Header Column' : 'Line Item';

  return (
    <Box>
      <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 1.5 }}>
        <Button
          variant="contained"
          size="small"
          startIcon={<Add />}
          onClick={onAdd}
          disabled={loading}
          sx={{ fontSize: '0.8125rem' }}
        >
          Add {label} Mapping
        </Button>
      </Box>

      <TableContainer component={Paper} sx={{ maxHeight: 'calc(100vh - 280px)' }}>
        <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              {columns.map((col) => (
                <TableCell key={col.key} sx={{ ...headSx, minWidth: col.width }}>
                  {col.label}
                </TableCell>
              ))}
              <TableCell sx={{ ...headSx, width: 88 }} align="right">
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {mappings.length === 0 ? (
              <TableRow>
                <TableCell colSpan={columns.length + 1} align="center" sx={{ py: 3, fontSize: '0.875rem' }}>
                  No mappings found
                </TableCell>
              </TableRow>
            ) : (
              mappings.map((mapping) => (
                <TableRow key={mapping.id} hover>
                  {columns.map((col) => {
                    const raw = mapping[col.key];
                    const display = col.format ? col.format(raw) : raw || '-';
                    return (
                      <TableCell key={col.key} sx={cellSx}>
                        {display}
                      </TableCell>
                    );
                  })}
                  <TableCell align="right" sx={{ py: 0.75 }}>
                    <Tooltip title="Edit">
                      <IconButton size="small" onClick={() => onEdit(mapping)} sx={{ p: 0.5 }}>
                        <Edit fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton size="small" onClick={() => onDelete(mapping)} sx={{ p: 0.5 }}>
                        <Delete fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default TransformationMappingTable;
